import { createSelector } from 'reselect'
import { LO } from '../../constants/agent_types'
import { selectSponsorship } from './sponsorship'
import { getCustomerPhotoUri, selectCustomerType, selectCustomerProfile } from './customerProfile'

export const selectLO = createSelector(
  selectCustomerType,
  selectCustomerProfile,
  selectSponsorship,
  (type, cp, sponsor) => (type === LO ? cp : sponsor)
)

export const selectLoanOfficerPhotoUri = createSelector(selectLO, getCustomerPhotoUri)
